export * from "-!../../../../node_modules/cache-loader/dist/cjs.js!../../../../node_modules/babel-loader/lib/index.js??ref--2-1!../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??ref--2!../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./FeaturedText.vue?vue&type=template&id=7e933d91&scoped=true"


//////////////////
// WEBPACK FOOTER
// ./scripts/vue/FeaturedText.vue?vue&type=template&id=7e933d91&scoped=true
// module id = 117
// module chunks = 0